import { useEffect, useState } from "react";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import { api, API } from "@/lib/api";
import { useCart } from "@/lib/cart";
import { useI18n } from "@/lib/i18n";
import { toast } from "sonner";
import { useNavigate } from "react-router-dom";

export default function PayPalCheckout({ email }) {
  const { items, clear } = useCart();
  const { t, lang } = useI18n();
  const nav = useNavigate();
  const [config, setConfig] = useState(null);

  const placeholderCopy = {
    de: "PayPal wird eingerichtet — bald verfügbar",
    en: "PayPal is being set up — coming soon",
    it: "PayPal in fase di attivazione — disponibile a breve",
    ja: "PayPalを準備中です — まもなくご利用いただけます",
    zh: "PayPal 正在开通——敬请期待",
  };

  const errorCopy = {
    de: { failed: "Zahlung fehlgeschlagen", error: "PayPal-Fehler" },
    en: { failed: "Payment failed", error: "PayPal error" },
    it: { failed: "Pagamento fallito", error: "Errore PayPal" },
    ja: { failed: "お支払いに失敗しました", error: "PayPalエラー" },
    zh: { failed: "支付失败", error: "PayPal 错误" },
  };
  const ec = errorCopy[lang] || errorCopy.en;

  useEffect(() => {
    fetch(`${API}/config`).then((r) => r.json()).then(setConfig).catch(() => {});
  }, []);

  if (!config) return null;

  if (!config.paypal_enabled) {
    return (
      <div className="text-center text-cream/40 text-xs font-body py-3 border border-dashed border-white/10" data-testid="paypal-disabled">
        {placeholderCopy[lang] || placeholderCopy.en}
      </div>
    );
  }

  return (
    <div className="w-full" data-testid="paypal-buttons-wrap">
      <PayPalScriptProvider
        options={{
          clientId: config.paypal_client_id,
          currency: "EUR",
          intent: "capture",
          "disable-funding": "credit,card,sepa",
        }}
      >
        <PayPalButtons
          style={{ layout: "horizontal", color: "gold", shape: "rect", label: "paypal", height: 48, tagline: false }}
          createOrder={async () => {
            const payload = {
              items: items.map((i) => ({ product_id: i.product.id, quantity: i.qty })),
              origin_url: window.location.origin,
              email: email || undefined,
            };
            const { data } = await api.post("/paypal/create-order", payload);
            return data.order_id;
          }}
          onApprove={async (data) => {
            try {
              const { data: cap } = await api.post(`/paypal/capture-order/${data.orderID}`);
              if (cap.payment_status === "paid") {
                clear();
                nav(`/payment/success?session_id=${data.orderID}&provider=paypal`);
              } else {
                toast.error(ec.failed);
              }
            } catch {
              toast.error(ec.error);
            }
          }}
          onError={() => toast.error(ec.error)}
          onCancel={() => nav("/payment/cancel")}
        />
      </PayPalScriptProvider>
    </div>
  );
}
